import React from 'react';

import { MINIMAL_HEADER, MINIMAL_FOOTER } from '../../constants';

import HeaderNavComponent from '../header/HeaderNavComponent';
import FooterComponent from '../footer/FooterComponent';
import { BreadcrumbComponent } from '../breadcrumb/BreadcrumbComponent';
import MinimalHeaderNavComponent from '../header/minimal/MinimalHeaderNavComponent';
import MinimalFooterComponent from '../footer/minimal/MinimalFooterComponent';

import { Template } from './TemplateStyle';

export const PrimaryTemplate = props => {
    return (
        <Template className="flex-container-v">
            {MINIMAL_HEADER ? <MinimalHeaderNavComponent /> : <HeaderNavComponent />}
            {!props.hideBreadcrumb && <BreadcrumbComponent />}
            {props.children}
            {MINIMAL_FOOTER ? <MinimalFooterComponent /> : <FooterComponent />}
        </Template>
    );
};



// WEBPACK FOOTER //
// ./src/components/template/PrimaryTemplate.js